var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFmhAudioBackground({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 2C36 0.89543 35.1046 0 34 0C32.8954 0 32 0.895431 32 2L32 114C32 115.105 32.8954 116 34 116C35.1046 116 36 115.105 36 114L36 2ZM68 21C68 19.8954 67.1046 19 66 19C64.8954 19 64 19.8954 64 21V94C64 95.1046 64.8954 96 66 96C67.1046 96 68 95.1046 68 94V21ZM18 22C19.1046 22 20 22.8954 20 24L20 92C20 93.1046 19.1046 94 18 94C16.8954 94 16 93.1046 16 92L16 24C16 22.8954 16.8954 22 18 22ZM4 44C4 42.8954 3.10457 42 2 42C0.895431 42 0 42.8954 0 44V71C0 72.1046 0.895431 73 2 73C3.10457 73 4 72.1046 4 71V44ZM116 44C116 42.8954 115.105 42 114 42C112.895 42 112 42.8954 112 44V71C112 72.1046 112.895 73 114 73C115.105 73 116 72.1046 116 71V44ZM98 29C99.1046 29 100 29.8954 100 31V88C100 89.1046 99.1046 90 98 90C96.8954 90 96 89.1046 96 88V31C96 29.8954 96.8954 29 98 29ZM50 7C51.1046 7 52 7.89543 52 9L52 108C52 109.105 51.1046 110 50 110C48.8954 110 48 109.105 48 108L48 9C48 7.89543 48.8954 7 50 7ZM84 9C84 7.89543 83.1046 7 82 7C80.8954 7 80 7.89543 80 9L80 108C80 109.105 80.8954 110 82 110C83.1046 110 84 109.105 84 108L84 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmhAudioBackground);
export default __webpack_public_path__ + "static/media/fmh-audio-background.89ad5973e204201eb98aa22be971b2fb.svg";
export { ForwardRef as ReactComponent };